"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = require("react-jss");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _reactJss.createUseStyles)({
  icon: {
    minWidth: function minWidth(props) {
      return props.width;
    },
    minHeight: function minHeight(props) {
      return props.height;
    }
  }
});
var SvgIcon = /*#__PURE__*/(0, _react.forwardRef)(function SvgIcon(_ref, ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      fillColor = _ref.fillColor,
      strokeColor = _ref.strokeColor,
      className = _ref.className,
      svg = _ref.svg,
      style = _ref.style,
      noFill = _ref.noFill;
  var classes = useStyles({
    width: width,
    height: height
  });
  var Svg = (0, _react.useMemo)(function () {
    return svg;
  }, [svg]);
  var iconFillColor = fillColor || color;
  return /*#__PURE__*/_react["default"].createElement(Svg, {
    ref: ref,
    width: width,
    height: height,
    className: (0, _classnames["default"])({
      'transition-all': iconFillColor && !noFill
    }, className, noFill ? 'fill-inherit' : ["fill-".concat(iconFillColor, " stroke-").concat(strokeColor)], classes.icon),
    style: style
  });
});
SvgIcon.defaultProps = {
  width: 20,
  height: 20,
  color: '',
  fillColor: '',
  strokeColor: '',
  className: '',
  style: {},
  noFill: false
};
SvgIcon.propTypes = {
  /** Icon width in pixels */
  width: _propTypes["default"].number,

  /** Icon height in pixels */
  height: _propTypes["default"].number,

  /** Icon fill color - see style guide colors for options - Deprecated use fillColor */
  color: _propTypes["default"].string,

  /** Icon fill color - see style guide colors for options */
  fillColor: _propTypes["default"].string,

  /** Icon stroke color - see style guide colors for options */
  strokeColor: _propTypes["default"].string,

  /** Class to add to the Icon component */
  className: _propTypes["default"].string,

  /** Style to add to Icon component */
  style: _propTypes["default"].shape(),

  /** The svg icon to render */
  svg: _propTypes["default"].oneOfType([_propTypes["default"].shape(), _propTypes["default"].func]).isRequired,

  /** boolean - decide whether to disable default fill color */
  noFill: _propTypes["default"].bool
}; // Hack for withInfo plugin

SvgIcon.displayName = 'SvgIcon';
var _default = SvgIcon;
exports["default"] = _default;